export class MassEmailArgs {
  public ReturnAddress: string;
  public Subject: string;
  public Body: string;
}
